// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-view_contentInnerContainer__IelUt","item":"tenant-view_item__REZbI"};